import {
  type QualificationHolidayFeeOverrideRow,
  type QualificationHolidayFeeOverrides,
} from "./types";

export function flattenHolidayFeeOverrides(
  overrides: QualificationHolidayFeeOverrides | undefined
): QualificationHolidayFeeOverrideRow[] {
  if (!overrides) {
    return [];
  }

  const result: QualificationHolidayFeeOverrideRow[] = [];
  for (const [qualification, override] of Object.entries(overrides)) {
    if (override?.type && typeof override?.increment === "number") {
      result.push({
        qualification,
        type: override.type,
        increment: override.increment,
      });
    }
  }

  result.sort((a, b) => a.qualification.localeCompare(b.qualification));

  return result;
}

export function addHolidayFeeOverride(
  overrides: QualificationHolidayFeeOverrides,
  override: QualificationHolidayFeeOverrideRow
): QualificationHolidayFeeOverrides {
  const { qualification, type, increment } = override;
  return {
    ...overrides,
    [qualification]: { type, increment },
  };
}

export function removeHolidayFeeOverride(
  overrides: QualificationHolidayFeeOverrides,
  qualification: string
): QualificationHolidayFeeOverrides {
  const { [qualification]: _removed, ...rest } = overrides;
  return rest;
}

export function hasHolidayFeeOverride(
  overrides: QualificationHolidayFeeOverrides,
  qualification: string
): boolean {
  const override = overrides[qualification];
  return Boolean(override?.type && typeof override?.increment === "number");
}
